import { create } from 'zustand';
import api from '../services/api';

export interface HistoryEntry {
  id?: number;
  url: string;
  label: string;
  timestamp: number;
}

interface NavigationHistoryState {
  entries: HistoryEntry[];
  loaded: boolean;
  load: () => Promise<void>;
  push: (url: string, label: string) => void;
  clear: () => Promise<void>;
}

export const useNavigationHistoryStore = create<NavigationHistoryState>((set, get) => ({
  entries: [],
  loaded: false,

  load: async () => {
    try {
      const res = await api.get<HistoryEntry[]>('/navigation-history/');
      set({ entries: res.data, loaded: true });
    } catch {
      set({ loaded: true });
    }
  },

  push: (url, label) => {
    const state = get();
    const last = state.entries[state.entries.length - 1];
    if (last && last.url === url) return;

    // Optimistic update
    const tempEntry: HistoryEntry = { url, label, timestamp: Date.now() };
    const newEntries = [...state.entries, tempEntry];
    if (newEntries.length > 100) newEntries.shift();
    set({ entries: newEntries });

    // Persist to backend (fire and forget)
    api.post('/navigation-history/push/', { url, label }).catch(() => {});
  },

  clear: async () => {
    set({ entries: [] });
    try {
      await api.delete('/navigation-history/clear/');
    } catch {
      // ignore
    }
  },
}));
